<template>
    <div class="home">
        <head-nav/>
        <main>
            <router-view/>
        </main>
        <foot/>
    </div>
</template>

<script>
    import HeadNav from "./HeadNav";
    import Foot from "./Foot";
    export default {
        name: "Home",
        components: {Foot, HeadNav}
    }
</script>

<style lang="scss" scoped>
    .home {
        background: url("https://static.makerfac.com/img/bg-head.png") no-repeat top center;
        background-size: 100%;
        overflow: hidden;
        main {
            min-height: 700px;
            position: relative;
            padding-bottom: 190px;
        }
    }
</style>
